"use strict";
// returns a random number from range between min and max
Object.defineProperty(exports, "__esModule", { value: true });
function randomInt(min = 1, max = 100) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}
exports.default = randomInt;
